// GSAP Animations

( function($) {

    window.onload = function(e){  // on load for GSAP
  
    gsap.registerPlugin(ScrollTrigger);
  
    console.log("animations.js ready");
  
      
      // RESPONSIVE FUNCTIONS:
      ScrollTrigger.matchMedia({
  
        
        // lg destkop:
      "(min-width: 992px)": function() {
        // setup animations and ScrollTriggers for screens 992px wide or greater (bootstrap large) here...
        // The ScrollTriggers created inside these functions are segregated and get reverted/killed when the media query doesn't match anymore. 
  
        
  // =======================================================
  // ***** DESKTOP: ARTICLE SIDEBAR PINS ******
  // =======================================================
       if( $('.js-sticky-filters').length ){         
         var pinWrapHeight = $('.component-collection').outerHeight(); // wrapper around pinned and unpinned content
         //var pinUnpinnedHeight = $('.js-gsap-wrapper-height').outerHeight(); // unpinned content height
         var pinElHeight = $('.collection-filter').outerHeight(); // pinned content height
         var pinDuration =  pinWrapHeight - pinElHeight; // wrapper minus unpinned minus pinned plus spacing below bottom product)
         //console.log("pinWrapHeight = " + pinWrapHeight + " | pinUnpinnedHeight = " + pinUnpinnedHeight + " | pinElHeight = " + pinElHeight + " | pinDuration = " + pinDuration + "");
            ScrollTrigger.create({
              trigger: ".component-collection",
              start: "top 155",
              end: self => "+=" + pinDuration,
              pinSpacing: true,
              markers: false,
              pin: ".js-sticky-filters"
            });            
        }
      },
        
      // md-desktop: 
      "(min-width: 768px)": function() {
        // setup animations and ScrollTriggers for screens 768px wide or greater (bootstrap med) here...
        // The ScrollTriggers created inside these functions are segregated and get reverted/killed when the media query doesn't match anymore. 
  
  
      },
  
        // mobile: 
      "(max-width: 767px)": function() {
        // setup animations and ScrollTriggers for screens 768px wide or less (mobile) here...
        // The ScrollTriggers created inside these functions are segregated and get reverted/killed when the media query doesn't match anymore. 
  
  
      },
  
      // all 
      "all": function() {
        // ScrollTriggers created here aren't associated with a particular media query,
        // so they persist.
  
      }
  
    }); 
  
  
    }; // end GSAP on load wrapper
  
  } ) ( jQuery );